import styled from 'styled-components';
import theme from 'theme/theme';
import media from 'utils/MediaQueries';

const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
	margin-top: 22px;

	${media.phone`
		/* Keep both badges on one line: at 375px two 168px badges plus the gap
		   overflow the padded hero column and wrap onto separate rows, which
		   reads as a broken stack rather than a pair. */
		flex-wrap: nowrap;
		gap: 10px;
		justify-content: center;
	`};
`;

const BadgeLink = styled.a`
	display: inline-block;
	line-height: 0;
	border-radius: 8px;

	&:focus-visible {
		outline: 2px solid ${theme.primary1};
		outline-offset: 3px;
	}

	${media.phone`
		/* Shrink together rather than wrapping; min-width:0 is what actually
		   lets a flex item go below its content size. */
		flex: 1 1 0;
		min-width: 0;
		max-width: 168px;
	`};
`;

const Badge = styled.img`
	display: block;
	width: 168px;
	height: 50px;
	/* The artwork is already letterboxed to a shared canvas, so a fixed box
	   here keeps both badges identical without distorting either logo. */
	object-fit: contain;

	${media.phone`
		width: 100%;
		height: auto;
	`};
`;

export { Row, BadgeLink, Badge };
